export const environment = {
  production: false,
  apiBaseUrl: 'https://api-app-hml-lcp.ukam.dev/v5',
};
